/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import Slider from '@material-ui/core/Slider';
import { withStyles } from '@material-ui/core/styles';
import Select from 'react-select';

import fechar from '../../img/fechar.svg';
import Mais from '../../img/icon_plus.svg';
import Delete from '../../img/icon_delete-red.svg';

import { ItemsCreators } from '../../../../store/actions/items';
import { IaCreators } from '../../../../store/actions/intelligence';

import './ModalCondicao.scss';
import ConditionResponse from './ConditionResponse/ConditionResponse';
import ModalVisibilidade from '../ModalVisibilidade/ModalVisibilidade';
import HelpBalloon from '../HelpBalloon/HelpBalloon';

const PrettoSlider = withStyles({
  root: {
    color: '#52af77',
    height: 8,
  },
  thumb: {
    height: 20,
    width: 20,
    backgroundColor: '#fff',
    border: '2px solid #0d84ff',
    marginTop: -6,
    marginLeft: -10,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

const ModalCondicao = (props) => {
  const { blt } = props;

  // Modal Condição
  const [modal, setModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [openNewCondition, setOpenNewCondition] = useState(false);

  // Bloco Escolhido e os Blocos Destinos
  const [destinationOption, setDestinationOption] = useState(null);
  const destinationOptions = props?.items.map((item) => {
    return {
      key: item._id,
      label: `${item.title} ${item._id}`,
      value: `${item.title} ${item._id}`,
    };
  });

  // Tipo da condição; se é intenção ou entidade
  const [ifOption, setIfOption] = useState(null);
  const [ifOption2, setIfOption2] = useState(null);
  const ifOptions = [
    { label: 'intenção', value: 'intent' },
    { label: 'entidade', value: 'entity' },
  ];

  // Quais condições existem
  const [conditionOptions, setConditionOptions] = useState([]);
  const [conditionOptions2, setConditionOptions2] = useState([]);

  // Qual Condição escolhida
  const [conditionOption, setConditionOption] = useState(null);
  const [conditionOption2, setConditionOption2] = useState(null);

  // Objeto com valores para criação da condição
  const initialConditionValues = {
    confidence: 50,
    active: true,
    intent: '',
    entity: '',
    destination: '',
    user: '',
    bot: '',
  };
  const [conditionValues, setConditionValues] = useState(
    initialConditionValues
  );

  useEffect(() => {
    return () => {
      clearValues();
    };
  }, []);

  useEffect(() => {
    if (JSON.stringify(props.editCondition) === '{}') setConditionOption(null);
    if (ifOption?.value === 'intent')
      setConditionOptions(
        props?.intents.map((intent) => {
          return { name: 'intent', label: intent?.name, value: intent?.name };
        })
      );
    else if (ifOption?.value === 'entity')
      setConditionOptions(
        props?.entities.map((entity) => {
          return { name: 'entity', label: entity?.name, value: entity?.name };
        })
      );
    else setConditionOptions([]);
  }, [ifOption]);

  useEffect(() => {
    if (JSON.stringify(props.editCondition) === '{}') setConditionOption2(null);
    if (ifOption2?.value === 'intent')
      setConditionOptions2(
        props?.intents.map((intent) => {
          return { name: 'intent', label: intent.name, value: intent.name };
        })
      );
    else if (ifOption2?.value === 'entity')
      setConditionOptions2(
        props?.entities.map((entity) => {
          return { name: 'entity', label: entity.name, value: entity.name };
        })
      );
    else setConditionOptions2([]);
  }, [ifOption2]);

  useEffect(() => {
    if (JSON.stringify(props.editCondition) !== '{}') {
      setConditionValues(props.editCondition);
      setDestinationOption(
        destinationOptions.filter(
          (item) => item.key === props.editCondition.destination
        )
      );
      if (props.editCondition.intent && props.editCondition.entity) {
        setOpenNewCondition(true);
        setIfOption({ label: 'intenção', value: 'intent' });
        setIfOption2({ label: 'entidade', value: 'entity' });
        setConditionOption({
          name: 'intent',
          value: props.editCondition.intent,
          label: props.editCondition.intent,
        });
        setConditionOption2({
          name: 'entity',
          value: props.editCondition.entity,
          label: props.editCondition.entity,
        });
      } else if (props.editCondition.intent) {
        setIfOption({ label: 'intenção', value: 'intent' });
        setConditionOption({
          name: 'intent',
          value: props.editCondition.intent,
          label: props.editCondition.intent,
        });
      } else {
        setIfOption({ label: 'entidade', value: 'entity' });
        setConditionOption({
          name: 'entity',
          value: props.editCondition.entity,
          label: props.editCondition.entity,
        });
      }
    } else {
      setConditionValues(initialConditionValues);
    }
  }, [props.editCondition]);

  const clickfechar = () => {
    setModal(false);
    clearValues();
  };

  const handleVisibilit = () => {
    setOpen(!open);
  };

  const clearValues = () => {
    props.setEditCondition({});
    setConditionValues(initialConditionValues);
    setDestinationOption(null);
    setIfOption(null);
    setIfOption2(null);
    setConditionOption(null);
    setConditionOption2(null);
    setOpenNewCondition(false);
  };

  const clearCondition2 = () => {
    const temp = { ...conditionValues };
    if (ifOption2?.value) temp[ifOption2.value] = '';
    setConditionOption2(null);
    setIfOption2(null);
    setOpenNewCondition(false);
    console.log(temp);
    setConditionValues(temp);
  };

  const handleChangeConditionValue = (option) => {
    const temp = { ...conditionValues };
    if (ifOption?.value) temp[ifOption.value] = option ? option.value : null;
    setConditionValues(temp);
    setConditionOption(option);
  };

  const handleChangeConditionValue2 = (option) => {
    const temp = { ...conditionValues };
    if (ifOption2?.value) temp[ifOption2.value] = option ? option.value : null;
    setConditionValues(temp);
    setConditionOption2(option);
  };

  const handleChangeDestinationValue = (option) => {
    const currentState = { ...conditionValues };
    currentState.destination = option ? option.key : '';
    setConditionValues(currentState);
    setDestinationOption(option);
  };

  const handleChangeIfValue = (option) => {
    setIfOption(option);
    if (option && openNewCondition)
      setIfOption2(ifOptions.find((elem) => elem.value !== option.value));
  };

  const handleChangeIfValue2 = (option) => {
    setIfOption2(option);
    if (option) {
      const possibleOption = ifOptions.find(
        (elem) => elem.value !== option.value
      );
      if (possibleOption.value !== ifOption.value) setIfOption(possibleOption);
    }
  };

  const handleChangeConfidence = (value) => {
    const temp = { ...conditionValues };
    temp.confidence = value;
    setConditionValues(temp);
  };

  const handleCreateCondition = () => {
    const { destination, intent, entity } = conditionValues;
    if (!destination)
      return toastr.error('Erro', 'Escolha um bloco destino para a condição');
    if (!(intent || entity))
      return toastr.error('Erro', 'Escolha a condição e seu tipo');
    if (openNewCondition && !(intent && entity))
      return toastr.error('Erro', 'Escolha a condição e seu tipo');
    props.createCondition({
      ...conditionValues,
      user: props.user._id,
      bot: props.match.params.botid,
    });
    setModal(false);
    clearValues();
  };

  const handleEditCondition = () => {
    const { destination, intent, entity } = conditionValues;
    if (!destination)
      return toastr.error('Erro', 'Escolha um bloco destino para a condição');
    if (!(intent || entity))
      return toastr.error('Erro', 'Escolha a condição e seu tipo');
    if (openNewCondition && !(intent && entity))
      return toastr.error('Erro', 'Escolha a condição e seu tipo');
    props.updateCondition(conditionValues);
    setModal(false);
    clearValues();
  };

  const criarAtivar = () => {
    if (JSON.stringify(props.editCondition) === '{}') handleCreateCondition();
    else handleEditCondition();
  };

  return (
    <div style={{ display: 'flex' }}>
      {modal === true && (
        <div className="modal-condicao">
          <div className="container-header-modal-condicao">
            <p>Nova Condição</p>{' '}
            <img
              onClick={clickfechar}
              src={fechar}
              style={{ cursor: 'pointer' }}
              alt="fechar"
            />
          </div>
          <div className="container-input-condicao">
            <div className="container-input-select">
              <div className="space-select">
                <span>se</span>
                <Select
                  className="condition-select"
                  placeholder="Selecione..."
                  isClearable
                  isSearchable
                  onChange={handleChangeIfValue}
                  value={ifOption}
                  options={ifOptions}
                />
              </div>
              <div className="space-select">
                <span>condição</span>
                <Select
                  className="condition-select"
                  placeholder="Selecione..."
                  isClearable
                  isSearchable
                  onChange={handleChangeConditionValue}
                  value={conditionOption}
                  options={conditionOptions}
                />
              </div>
            </div>

            {!openNewCondition ? (
              <div className="container-mais-condicao">
                <img
                  src={Mais}
                  alt="mais"
                  onClick={() => setOpenNewCondition(true)}
                />
              </div>
            ) : (
              <>
                <div className="container-mais-condicao">e</div>
                <div className="container-delete-condicao">
                  <img
                    src={Delete}
                    alt="deleteCondition"
                    onClick={() => clearCondition2()}
                  />
                </div>
                <div className="container-input-select">
                  <div className="space-select">
                    <span>se</span>
                    <Select
                      className="condition-select"
                      placeholder="Selecione..."
                      isClearable
                      isSearchable
                      onChange={handleChangeIfValue2}
                      value={ifOption2}
                      options={ifOptions}
                    />
                  </div>
                  <div className="space-select">
                    <span>condição</span>
                    <Select
                      className="condition-select"
                      placeholder="Selecione..."
                      isClearable
                      isSearchable
                      onChange={handleChangeConditionValue2}
                      value={conditionOption2}
                      options={conditionOptions2}
                    />
                  </div>
                </div>
              </>
            )}

            <div className="input-body">
              <span>
                Taxa de Confiança: {`${conditionValues?.confidence}%`}
                <HelpBalloon
                  id="confidenceRate"
                  message="Grau de certeza que a IA vai categorizar um texto."
                />
              </span>
              <PrettoSlider
                aria-label="pretto slider"
                step={1}
                min={0}
                max={100}
                name="confidence"
                onChange={(e, value) => handleChangeConfidence(value)}
                value={conditionValues?.confidence || 0}
              />
            </div>
          </div>
          <div className="container-bloco">
            <span>
              ir para
              <HelpBalloon
                id="goTo"
                message="Qual o fluxo o bot irá seguir se o retorno de confiança for o estabelecido."
              />
            </span>
            <Select
              className="condition-select modal-condicao-bloco-destino"
              placeholder="Selecione..."
              isClearable
              isSearchable
              onChange={handleChangeDestinationValue}
              value={destinationOption}
              options={destinationOptions}
            />
          </div>
          <div className="container-footer">
            <button type="button" onClick={criarAtivar}>
              {JSON.stringify(props.editCondition) === '{}'
                ? 'criar e ativar'
                : 'editar'}
            </button>
          </div>
        </div>
      )}

      <ModalVisibilidade open={open} handleVisibilit={handleVisibilit} />

      <ConditionResponse
        blt={blt}
        modal={modal}
        openModal={() => setModal(true)}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  items: state.items.allItems,
  user: state.users.signedUser,
  intents: state.intelligence.intents,
  entities: state.intelligence.entities,
  editCondition: state.intelligence.editCondition,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...ItemsCreators, ...IaCreators }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ModalCondicao))
);
